module.exports = __webpack_public_path__ + "d1632fcda264d6d566745719d66a74f1.glb";